import React from "react";
import { TextIconView } from "./view";
import { styles } from "./styles";

export const TextIcon = props => <TextIconView {...props} styles={styles} />;
